import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { Props as DynamicLinkProps } from 'Components/frameworks/dynamic-link/DynamicLink';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Title } from 'Components/frameworks/title/Title';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import { themes } from './CardHeading.themes';
export type CardHeadingProps = {
  color?: Colors;
  dataTestIdPrefix?: string;
  hLevel?: number;
  iconName?: IconName;
  link?: DynamicLinkProps | null | undefined;
  small?: ReactNode;
  subtitle?: ReactNode;
  theme?: keyof typeof themes;
  title?: ReactNode;
};
export const CardHeading = ({
  color,
  dataTestIdPrefix = 'CardHeading',
  hLevel = 2,
  iconName,
  link,
  small,
  subtitle,
  theme = 'default',
  title,
}: CardHeadingProps) => {
  if (!title) {
    return null;
  }

  const { thSmall, thSubtitle, thSubtitleTheme, thTitleTheme } = themes[theme];

  // eslint-disable-next-line clubmed/no-fake-component
  const withLink = (node) =>
    link?.url ? (
      <DynamicLink {...link} className="block">
        {node}
      </DynamicLink>
    ) : (
      node
    );

  return withLink(
    <Fragment>
      <Title
        dataTestId={`${dataTestIdPrefix}-title`}
        hLevel={hLevel}
        iconName={iconName}
        theme={thTitleTheme}
      >
        {title}
        {!!small && <small className={thSmall}>{small}</small>}
      </Title>
      {!!subtitle && (
        <Title
          className={classnames(thSubtitle, `text-${color || 'black'}`)}
          dataTestId={`${dataTestIdPrefix}-subtitle`}
          hLevel={hLevel < 6 ? hLevel + 1 : 6}
          theme={thSubtitleTheme}
        >
          {subtitle}
        </Title>
      )}
    </Fragment>,
  );
};
